/* eslint-disable react/require-default-props */
import { useMemo } from 'react';
import { Article } from 'Types/ArticleTypes';
import { IsMobile, splitArrayChunks } from 'Utils/UtilityFunctions';
import styled from 'styled-components';
import ArticleGridChunk from './ArticleGridChunk';

const AritclesGridLayout = styled.div``;

type Props = {
  articlesArray: Article[] | null | undefined,
  listview?: boolean
  isLoading?: boolean
};

const ArticleGridLayout = function (props: Props) {
  const {
    articlesArray,
    listview = false,
    isLoading = false,
  } = props;

  const isMobile = IsMobile();

  const chunks = useMemo(() => (
    articlesArray && articlesArray.length > 0
      ? splitArrayChunks(articlesArray, 5, isMobile, listview)
      : []
  ), [articlesArray, isMobile, listview]);

  return (
    <AritclesGridLayout>
      {chunks.map((chunk, index) => {
        const isReversed = (!isMobile && !(index % 2 === 0));
        return (
          <div key={`article-chunk-${chunk[0]?.articleId ?? index}`}>
            <ArticleGridChunk
              chunk={chunk}
              isReversed={isReversed}
              listview={listview}
              isLoading={isLoading}
            />
          </div>
        );
      })}
    </AritclesGridLayout>
  );
};

export default ArticleGridLayout;
